export const ENV_CONFIG_DEFAULT = Object.freeze({
    API_URL: process.env.REACT_APP_API_URL,
    API_TIME_OUT: 10000,
    API_PUSH_URL: process.env.REACT_APP_PUSH_URL,
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL as string,
});
